import React from 'react'
import foot from '../../../assests/home/shape-bg.png'
import './Footer.css'

export const Footer = () => {
  return (
    <div className='fContainer'>
        <div className='fParent'>
            <img src={foot} alt="" />
        </div>
    </div>
  )
}
